import React from 'react';

const items = [
  { icon: 'fa-truck', title: 'Volledige Service', text: 'Volledige setup & cleanup\nProfessioneel uniformed team' },
  { icon: 'fa-leaf', title: 'Dieetwensen Perfect', text: 'Vegan, glutenvrij, halal – iedereen kan genieten' },
  { icon: 'fa-tag', title: 'Op Maat Voorstel', text: 'Persoonlijk advies en een voorstel op maat voor uw event' },
  { icon: 'fa-shield-alt', title: 'Zorgeloos Genieten', text: 'Backup plan altijd ready\nReal-time communicatie\nTevreden gasten' },
];

const ValueProps: React.FC = () => {
  return (
    <section className="py-10 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6">
          <h2 className="text-xl sm:text-2xl font-serif font-bold">
            Altijd <span className="text-friet-red">Inbegrepen</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((it, idx) => (
            <div key={idx} className="text-center">
              <i className={`fas ${it.icon} text-xl text-friet-red mb-2`}></i>
              <h3 className="text-sm sm:text-base font-serif font-bold mb-1">{it.title}</h3>
              <p className="text-xs text-gray-600 leading-relaxed whitespace-pre-line font-serif">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;
